<script lang="ts" setup>
  import type { HorizontalNavItems, NavGroup, NavLink } from '@layouts/types';

  import { HorizontalNavGroup, HorizontalNavLink } from '@layouts/components';

  defineProps<{
    navItems: HorizontalNavItems;
  }>();

  const resolveNavItemComponent = (item: NavLink | NavGroup) => {
    if ('children' in item) 
return HorizontalNavGroup;

    return HorizontalNavLink;
  };
</script>

<template>
  <ul class="nav-items">
    <Component :is="resolveNavItemComponent(item)" v-for="(item, index) in navItems" :key="index" :item="item" />
  </ul>
</template>

<style lang="scss">
  .layout-wrapper.layout-nav-type-horizontal {
    .nav-items {
      display: flex;
      flex-wrap: wrap;
    }
  }
</style>
